import { CheckoutPaymentSelector } from 'features/payment/checkout';

import { useCheckoutContext } from '../../hooks/use-checkout-context';
import { useCheckoutLoadingState } from '../../hooks/use-checkout-loading-state';

export const PaymentSelector = () => {
  const {
    isSubmittingOrder,
    isLoadingPaymentMethods,
    isCheckoutLoading,
  } = useCheckoutLoadingState();
  const {
    showReloadPaymentMethods,
    reloadAmount,
    paymentMethods,
    checkoutPaymentMethodId,
    checkoutPaymentMethod,
    serverOrder,
  } = useCheckoutContext();

  return (
    <CheckoutPaymentSelector
      cart={serverOrder?.cart}
      checkoutPaymentMethod={checkoutPaymentMethod}
      checkoutPaymentMethodId={checkoutPaymentMethodId}
      isCheckoutLoading={isCheckoutLoading}
      isLoadingPaymentMethods={isLoadingPaymentMethods}
      isSubmittingOrder={isSubmittingOrder}
      paymentMethods={paymentMethods}
      reloadAmount={reloadAmount}
      showReloadPaymentMethods={showReloadPaymentMethods}
    />
  );
};
